<!-- =========================================================================================
    File Name: ResetPassword.vue
    Description: Reset Password Page
    ----------------------------------------------------------------------------------------
    Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
      Author: Pixinvent
    Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->


<template>
  <div class="h-screen flex w-full bg-img">
    <div class="vx-col sm:w-2/4 md:w-1/3 lg:w-2/4 mx-auto self-center" v-if="show">
      <vx-card>
        <div slot="no-body" class="full-page-bg-color">
          <div class="vx-row">
            <div class="vx-col sm:w-full md:w-full lg:w-full mx-auto self-center d-theme-dark-bg">
              <div class="p-8">
                <div class="vx-card__title mb-8">
                  <h4 class="mb-4">Wachtwoord herstellen</h4>
                  <p>Verzin een nieuw wachtwoord</p>
                </div>
                <vs-input
                  type="password"
                  label-placeholder="Wachtwoord"
                  v-model="password"
                  class="w-full mb-6"
                />
                <vs-input
                  type="password"
                  label-placeholder="Herhaal wachtwoord"
                  v-model="repeatPassword"
                  class="w-full mb-8"
                />
                <vs-button
                  class="float-right save--button"
                  :disabled="validatePassword"
                  @click="updatePassword"
                >Opslaan</vs-button>
              </div>
            </div>
          </div>
        </div>
      </vx-card>
    </div>
    <div class="vx-col sm:w-2/4 md:w-1/3 lg:w-2/4 mx-auto self-center" v-if="showError">
      <vx-card>
        <div slot="no-body" class="full-page-bg-color">
          <div class="vx-row">
            <div class="vx-col sm:w-full md:w-full lg:w-full mx-auto self-center d-theme-dark-bg">
              <div class="p-8">
                <h1>Link is verlopen</h1>
              </div>
            </div>
          </div>
        </div>
      </vx-card>
    </div>
     <div class="vx-col sm:w-2/4 md:w-1/3 lg:w-2/4 mx-auto self-center" v-if="showComplete">
      <vx-card>
        <div slot="no-body" class="full-page-bg-color">
          <div class="vx-row">
            <div class="vx-col sm:w-full md:w-full lg:w-full mx-auto self-center d-theme-dark-bg">
              <div class="p-8">
                <h2>Je wachtwoord is geupdated</h2>
                <a href="/login">Terug naar inloggen</a>
              </div>
            </div>
          </div>
        </div>
      </vx-card>
    </div>
  </div>
</template>

<script>
export default {
  computed: {
    validatePassword: function () {
      if (this.password === "" && this.repeatPassword === "") {
        return true;
      }
      return this.password !== this.repeatPassword;
    },
  },
  data() {
    return {
      show: false,
      showError: false,
      showComplete: false,
      password: "",
      repeatPassword: "",
      value3: "",
    };
  },
  methods: {
    getAddress: function () {
      if (this.postcode === null) {
        return;
      }
      if (this.deliverer.housenumber === "") {
        return;
      }
      this.$http
        .get(
          "https://staffapi.hebtrek.nl/v1/address?api_token=" +
            JSON.parse(localStorage.getItem("stafftoken")),
          {
            params: {
              zipcode: this.deliverer.postal_code,
              number: this.deliverer.housenumber,
            },
          }
        )
        .then((response) => {
          this.deliverer.address =
            response.data.street +
            " " +
            response.data.number +
            ", " +
            response.data.postcode +
            ", " +
            response.data.city;
          this.deliverer.street = response.data.street;
          this.deliverer.city = response.data.city;
        })
        .catch((error) => {
          this.$util.logError(error, this.$vs);
        });
    },
    updatePassword() {
      let key = this.$route.params.key;
      let data = {
        _method: "POST",
        password: this.repeatPassword,
        token: key,
      };
      let url =
        "https://companyapi.hebtrek.nl/v1/company-contact/update-password";
      this.$http
        .post(url, data, {
          headers: {
            Authorization:
              "Bearer " + JSON.parse(localStorage.getItem("companytoken")),
          },
        })
        .then((response) => {
          this.show = false;
          this.showComplete = true;
        })
        .catch((error) => {
          this.$util.logError(error, this.$vs);
        });
    },
  },
  mounted() {
    let key = this.$route.params.key;
    let data = {
      _method: "POST",
      key: key,
    };
    let url = "https://companyapi.hebtrek.nl/v1/company-contact/verify-key";
    this.$http
      .post(url, data, {
        headers: {
          Authorization:
            "Bearer " + JSON.parse(localStorage.getItem("companytoken")),
        },
      })
      .then((response) => {
        this.show = true;
      })
      .catch((error) => {
        this.showError = true;
      });
  },
};
</script>
<style scoped>
.save--button {
  margin-bottom: 25px !important;
}
</style>
